module.exports = __webpack_public_path__ + "static/img/Visualization4.274000fe.png";